import React, { Fragment } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { COLORS } from "../../constants";
import DesktopTradeSlideShow from "./DesktopTradeSlideShow";
import RsvpForm from "./RsvpForm";

const DesktopTradeShow = ({
  selectedYear,
  handleYearChange,
  control,
  errors,
  onSubmitClick,
  isRsvpModalOpen,
  onRsvpModalClose,
  createEventResponseCallStatus,
  setSelectedYear,
  imageUrls,
  isMobile,
  availableYears,
}) => {
  const getImageUrl = () =>
    `https://argusweb.azureedge.net/argus-web/home/hero-4${
      isMobile ? "-mobile" : ""
    }.jpg`;

  const renderRightSection = () => {
    if (selectedYear !== "2026") {
      return (
        <DesktopTradeSlideShow
          selectedYear={selectedYear}
          imageUrls={imageUrls}
        />
      );
    }

    return (
      // <Box
      //   sx={{
      //     minHeight: "60vh",
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //     backgroundColor: COLORS.white,
      //   }}
      // >
      //   <img
      //     src="/comingSoonDesktop.png"
      //     alt="Trade Show 2026 - Coming Soon"
      //     style={{
      //       width: "100%",
      //       maxWidth: "900px",
      //       height: "auto",
      //       objectFit: "contain",
      //     }}
      //   />
      // </Box>

      <RsvpForm
        control={control}
        errors={errors}
        onSubmitClick={onSubmitClick}
        isRsvpModalOpen={isRsvpModalOpen}
        onRsvpModalClose={onRsvpModalClose}
        createEventResponseCallStatus={createEventResponseCallStatus}
        setSelectedYear={setSelectedYear}
      />
    );
  };

  return (
    <Fragment>
      <Typography
        sx={{
          paddingLeft: 0,
          backgroundColor: "none",
          fontSize: isMobile ? "var(--font-size-l)" : "var(--font-size-xl)",
          fontWeight: 500,
          my: 4,
        }}
      >
        Trade Show
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} md={3}>
          <Box
            sx={{
              backgroundColor: COLORS.white,
              borderRadius: "2px",
              p: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h5"
              sx={{ color: COLORS.darkText, mb: 2, fontWeight: 600 }}
            >
              Argus Motoring Trade Show
            </Typography>
            <Typography variant="body1" sx={{ color: COLORS.lightText, mb: 4 }}>
              Argus Motor Company’s annual Trade Show in Brentwood Park
              highlights its extensive inventory of 30,000+ items, featuring
              DOE, BETA, and Argus Motoring brands. Industry professionals
              network with the team, discover new products, and witness live
              demos—upholding the company’s legacy of automotive excellence
              since 1955.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                pb: 2,
                flexWrap: "wrap",
              }}
            >
              {["2026", ...availableYears].map((year) => (
                <Box
                  key={year}
                  onClick={() => handleYearChange(year)}
                  sx={{
                    backgroundColor:
                      selectedYear === year ? COLORS.themeRed : COLORS.white,
                    color: selectedYear === year ? COLORS.white : COLORS.gray,
                    border:
                      selectedYear === year
                        ? "none"
                        : `1px solid ${COLORS.border}`,
                    px: 4,
                    py: 1,
                    borderRadius: 3,
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: "center",
                      justifySelf: "center",
                    }}
                  >
                    {year}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          {renderRightSection()}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default DesktopTradeShow;
